const INVALID_STORAGE_VALUES = new Set(['', 'null', 'undefined'])

function normalizeStoredValue(value) {
  if (value == null) {
    return ''
  }

  const normalized = String(value).trim()
  return INVALID_STORAGE_VALUES.has(normalized) ? '' : normalized
}

export function getAdminToken() {
  return normalizeStoredValue(localStorage.getItem('token'))
}

export function getRefreshToken() {
  return normalizeStoredValue(localStorage.getItem('refreshToken'))
}

export function getAdminUserInfo() {
  const raw = normalizeStoredValue(localStorage.getItem('userInfo'))
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    console.error('解析后台用户信息失败:', error)
    return null
  }
}

export function hasAdminSession() {
  return Boolean(getAdminToken())
}

export function getAdminPermissions(userInfo = getAdminUserInfo()) {
  return Array.isArray(userInfo?.permissions) ? userInfo.permissions : []
}

export function isSuperAdminUser(userInfo = getAdminUserInfo()) {
  const permissions = getAdminPermissions(userInfo)
  return userInfo?.roleCode === 'super_admin'
    || userInfo?.username === 'admin'
    || permissions.includes('*')
}

export const HIDDEN_COUPON_PASSWORD = '******'

export function canViewCouponPassword(userInfo = getAdminUserInfo()) {
  return isSuperAdminUser(userInfo)
}

export function maskCouponPassword(value, userInfo = getAdminUserInfo()) {
  if (value == null || value === '' || value === '-') {
    return value
  }
  return canViewCouponPassword(userInfo) ? value : HIDDEN_COUPON_PASSWORD
}

export function hasAdminPermission(permission, userInfo = getAdminUserInfo()) {
  if (!permission) {
    return false
  }

  if (isSuperAdminUser(userInfo)) {
    return true
  }

  const permissions = getAdminPermissions(userInfo)
  return permissions.some((granted) => {
    if (granted === permission) {
      return true
    }
    if (typeof granted === 'string' && granted.endsWith(':*')) {
      const namespace = granted.slice(0, -2)
      return permission === namespace || permission.startsWith(`${namespace}:`)
    }
    return false
  })
}

export function hasAnyAdminPermission(requiredPermissions = [], userInfo = getAdminUserInfo()) {
  return requiredPermissions.some((permission) => hasAdminPermission(permission, userInfo))
}

export function clearAdminSession() {
  localStorage.removeItem('token')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('adminTabs')
  localStorage.removeItem('adminActiveTab')
}
